module.exports = __webpack_public_path__ + "static/media/3lineas.c8f48451.svg";